import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { Certificate1, Certificate2 } from "src/assets";
import { Box, CardMedia, Divider, Stack } from "@mui/material";

const CertificateSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <Stack
        sx={{
          maxWidth: { sm: "300px" },
          textAlign: { xs: "center", sm: "start" },
        }}
      >
        <Text
          text={t("common.CertificateSection.title")}
          sx={{
            fontWeight: 700,
            lineHeight: "21px",
          }}
        />
      </Stack>

      <Stack
        gap={{ sm: 15, lg: 25 }}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Stack gap={5} direction={"row"} alignItems={"center"} sx={{ mt: 5 }}>
          <Box
            sx={{
              height: "153px",
              width: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CardMedia
              alt="Zertifikat1"
              component="img"
              image={Certificate1}
              sx={{
                height: "100%",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>

          <Box
            sx={{
              height: "153px",
              width: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CardMedia
              alt="Zertifikat2"
              component="img"
              image={Certificate2}
              sx={{
                height: "100%",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        </Stack>
      </Stack>
      <Divider sx={{ display: { sm: "none" } }} />
    </>
  );
};

export default CertificateSection;
